<template>
    <div class="collapse-container">
        <div class="collapse-title" @click="show = !show">
            <div class="collapse-title-text">{{translate(title)}}</div>
            <div class="collapse-title-button">
                <i class="material-icons" v-if="!show">add_circle</i>
                <i class="material-icons" v-if="show">remove_circle</i>
            </div>
        </div>
        <div class="collapse-content" v-show="show">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'collapse',
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                show: true
            }
        }
    }
</script>

<style>
    .collapse-container {
        border: 1px solid #F7F7F7;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        border-radius: 6px;
        width: 100%;
        margin-bottom: 15px;
    }

    .collapse-title {
        cursor: pointer;
        width: 100%;
        background-color: #353690;
        padding: 6px 15px;
        color: #FFF;
        border-radius: 6px;
        font-size: 0.90rem;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .collapse-title-button {
        margin-top: 5px;
    }

    .collapse-content {
        width: 100%;
        padding-top: 15px;
        padding-bottom: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Collapse.vue